function thuykieuDuLichHaTinhPrompt() {
  return `
    Bạn là Thúy Kiều, trợ lý ảo của StarGlobal 3D. Hãy giao tiếp bằng chất giọng Hà Nội chuẩn, ngữ điệu nhẹ nhàng, truyền cảm và sâu sắc. Đặc biệt, luôn giữ thái độ lễ phép, sử dụng từ "dạ, thưa" một cách tự nhiên để thể hiện sự trân trọng đối với khách hàng, luôn xưng mình là "Em".
    
    QUY TẮC XƯNG HÔ BẮT BUỘC: Luôn gọi khách hàng là "anh chị" (viết liền như một cụm từ, ví dụ: "Dạ, anh chị ơi", "Em xin chào anh chị", "Anh chị muốn xem gì ạ?"). KHÔNG ĐƯỢC tự động phân biệt giới tính dựa trên giọng nói hay bất kỳ yếu tố nào khác. KHÔNG ĐƯỢC chỉ gọi là "anh" hoặc chỉ gọi là "chị". Phải luôn sử dụng "anh chị" như một cụm từ thống nhất trong mọi câu trả lời.
    Bạn có thể giúp người dùng dễ dàng tương tác, khám phá không gian 3D/360 số hóa chỉ bằng trò chuyện, không cần thao tác thủ công. Bạn hỗ trợ thuyết minh, tạo tour, xem mô hình 3D, mở video, tài liệu...
    
    StarGlobal 3D sở hữu bằng sáng chế của USPTO cho “Web/App 3D/360 tương tác thông minh”, cho phép tái hiện không gian thực dưới dạng web tương tác 3D/360, truy cập từ xa mọi lúc, mọi nơi.
    Giải pháp tích hợp ảnh 360, đo đạc kích thước, thông tin đa phương tiện (audio, video, ảnh, bản đồ), tương tác mô hình 3D, đổi họa tiết sản phẩm. Ứng dụng đa ngành: Du lịch, Bảo tàng, Di sản, Trường học, Hạ tầng, Bất động sản, Nhà máy, Trang trại, Showroom, Triển lãm...
    Liên hệ:
    
    Hotline: (+84) 28 7303 4879 | (+84) 944 850 527
    Founder & CEO: Ông Trần Duy Hào – Tiến sĩ danh dự, nhà sáng chế được USPTO cấp bằng sáng chế cho hệ thống quản lý thông minh bản đồ số hóa 3D/360 (https://patents.google.com/patent/US10922881B2/en), hơn 20 năm kinh nghiệm quốc tế trong Chuyển đổi số, Dầu khí, Hàng không.
    Tính năng nổi bật:
    Công nghệ độc quyền, bảo hộ tại Mỹ & Việt Nam
    Tương tác tối ưu: autotour, đo đạc 3D/360, virtual check-in, chia sẻ mạng xã hội
    Kết nối IoT dữ liệu thời gian thực
    Đa nền tảng: di động, máy tính, kính VR, v.v.

    QUY ƯỚC ĐỌC CÁC CỤM TỪ VIẾT TẮT BẮT BUỘC:
        - Khi trả lời bằng tiếng Việt, nếu gặp các cụm từ sau trong tên doanh nghiệp, tổ chức, dự án..., hãy đọc thành dạng đầy đủ, KHÔNG đánh vần từng chữ cái:
          + "CBT" → đọc là "Si Bi Ti" 
          + "Thế kỷ XVIII" → đọc là "Thế kỷ 18"
        - Ví dụ: "CBT biển Thịnh Lộc" → đọc là "Si Bi Ti biển Thịnh Lộc"

    `;
}

function thuykieuDuLichHaTinhAvatar(nodes, materials) {
  return (
    <>
   <skinnedMesh
        geometry={nodes.AoDaiBK001.geometry}
        material={materials['DefaultMaterial.001']}
        skeleton={nodes.AoDaiBK001.skeleton}
      />
      <skinnedMesh
        geometry={nodes.AoDaiBK002.geometry}
        material={materials['Ta ao']}
        skeleton={nodes.AoDaiBK002.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body002.geometry}
        material={materials.arm}
        skeleton={nodes.body002.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body003.geometry}
        material={materials.arm}
        skeleton={nodes.body003.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body004.geometry}
        material={materials.leg}
        skeleton={nodes.body004.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body005.geometry}
        material={materials.leg}
        skeleton={nodes.body005.skeleton}
      />
      <skinnedMesh
        geometry={nodes.body009.geometry}
        material={materials.eyelash}
        skeleton={nodes.body009.skeleton}
      />
      <skinnedMesh
        name="body016"
        geometry={nodes.body016.geometry}
        material={materials.eyelash}
        skeleton={nodes.body016.skeleton}
        morphTargetDictionary={nodes.body016.morphTargetDictionary}
        morphTargetInfluences={nodes.body016.morphTargetInfluences}
      />
      <skinnedMesh
        geometry={nodes.body018.geometry}
        material={materials.eyelash}
        skeleton={nodes.body018.skeleton}
      />
      <skinnedMesh
        name="body021"
        geometry={nodes.body021.geometry}
        material={materials.teeth}
        skeleton={nodes.body021.skeleton}
        morphTargetDictionary={nodes.body021.morphTargetDictionary}
        morphTargetInfluences={nodes.body021.morphTargetInfluences}
      />
      <skinnedMesh
        name="body022"
        geometry={nodes.body022.geometry}
        material={materials.teeth}
        skeleton={nodes.body022.skeleton}
        morphTargetDictionary={nodes.body022.morphTargetDictionary}
        morphTargetInfluences={nodes.body022.morphTargetInfluences}
      />
      <skinnedMesh
        name="body023"
        geometry={nodes.body023.geometry}
        material={materials.teeth}
        skeleton={nodes.body023.skeleton}
        morphTargetDictionary={nodes.body023.morphTargetDictionary}
        morphTargetInfluences={nodes.body023.morphTargetInfluences}
      />
      <skinnedMesh
        name="EyeLeft"
        geometry={nodes.EyeLeft.geometry}
        material={materials.cornea}
        skeleton={nodes.EyeLeft.skeleton}
        morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
        morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
      />
      <skinnedMesh
        name="EyeRight"
        geometry={nodes.EyeRight.geometry}
        material={materials.cornea}
        skeleton={nodes.EyeRight.skeleton}
        morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
        morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
      />
      <skinnedMesh
        name="PupilLeft"
        geometry={nodes.PupilLeft.geometry}
        material={materials.pupil}
        skeleton={nodes.PupilLeft.skeleton}
        morphTargetDictionary={nodes.PupilLeft.morphTargetDictionary}
        morphTargetInfluences={nodes.PupilLeft.morphTargetInfluences}
      />
      <skinnedMesh
        name="PupilRight"
        geometry={nodes.PupilRight.geometry}
        material={materials.pupil}
        skeleton={nodes.PupilRight.skeleton}
        morphTargetDictionary={nodes.PupilRight.morphTargetDictionary}
        morphTargetInfluences={nodes.PupilRight.morphTargetInfluences}
      />
      <skinnedMesh
        geometry={nodes.shoe.geometry}
        material={materials.shoes}
        skeleton={nodes.shoe.skeleton}
      />
      <skinnedMesh
        geometry={nodes.shoe001.geometry}
        material={materials.shoes}
        skeleton={nodes.shoe001.skeleton}
      />
      <primitive object={nodes.root} />
      <primitive object={nodes['MCH-torsoparent']} />
      <primitive object={nodes['MCH-hand_ikparentL']} />
      <primitive object={nodes['MCH-upper_arm_ik_targetparentL']} />
      <primitive object={nodes['MCH-hand_ikparentR']} />
      <primitive object={nodes['MCH-upper_arm_ik_targetparentR']} />
      <primitive object={nodes['MCH-foot_ikparentL']} />
      <primitive object={nodes['MCH-thigh_ik_targetparentL']} />
      <primitive object={nodes['MCH-foot_ikparentR']} />
      <primitive object={nodes['MCH-thigh_ik_targetparentR']} />
      <skinnedMesh
        name="body025"
        geometry={nodes.body025.geometry}
        material={materials.head}
        skeleton={nodes.body025.skeleton}
        morphTargetDictionary={nodes.body025.morphTargetDictionary}
        morphTargetInfluences={nodes.body025.morphTargetInfluences}
      />
      <skinnedMesh
        name="body025_1"
        geometry={nodes.body025_1.geometry}
        material={materials.body}
        skeleton={nodes.body025_1.skeleton}
        morphTargetDictionary={nodes.body025_1.morphTargetDictionary}
        morphTargetInfluences={nodes.body025_1.morphTargetInfluences}
      />
      <skinnedMesh
        name="body025_2"
        geometry={nodes.body025_2.geometry}
        material={materials.lips}
        skeleton={nodes.body025_2.skeleton}
        morphTargetDictionary={nodes.body025_2.morphTargetDictionary}
        morphTargetInfluences={nodes.body025_2.morphTargetInfluences}
      />
      <skinnedMesh
        name="body025_3"
        geometry={nodes.body025_3.geometry}
        material={materials.lacrimal}
        skeleton={nodes.body025_3.skeleton}
        morphTargetDictionary={nodes.body025_3.morphTargetDictionary}
        morphTargetInfluences={nodes.body025_3.morphTargetInfluences}
      />
      <skinnedMesh
        name="hair001"
        geometry={nodes.hair001.geometry}
        material={materials.hair_front}
        skeleton={nodes.hair001.skeleton}
        morphTargetDictionary={nodes.hair001.morphTargetDictionary}
        morphTargetInfluences={nodes.hair001.morphTargetInfluences}
      />
      <skinnedMesh
        name="hair001_1"
        geometry={nodes.hair001_1.geometry}
        material={materials.hair_back}
        skeleton={nodes.hair001_1.skeleton}
        morphTargetDictionary={nodes.hair001_1.morphTargetDictionary}
        morphTargetInfluences={nodes.hair001_1.morphTargetInfluences}
      />

    </>
  );
}

export { thuykieuDuLichHaTinhPrompt, thuykieuDuLichHaTinhAvatar };
